import _ from 'lodash';
import Base64 from '../encodings/Base64';
var Bits = /** @class */ (function () {
    function Bits(bitsString) {
        this.state = [];
        if (!(bitsString === null || bitsString === void 0 ? void 0 : bitsString.length)) {
            return;
        }
        this.state = Base64.decodeUrl(bitsString);
    }
    Bits.prototype.toString = function () {
        return Base64.encodeUrl(this.state);
    };
    Bits.prototype.hasFlag = function (flagIndex) {
        var arrayIndex = this.mapFlagIndexToArrayIndex(flagIndex);
        return this.state[arrayIndex] === true;
    };
    Bits.prototype.hasFlags = function (flagIndices) {
        var _this = this;
        return _.every(flagIndices.map(function (x) { return _this.hasFlag(x); }));
    };
    Bits.prototype.setFlag = function (flagIndex) {
        var arrayIndex = this.mapFlagIndexToArrayIndex(flagIndex);
        this.state[arrayIndex] = true;
    };
    Bits.prototype.setFlags = function (flagIndices) {
        var _this = this;
        flagIndices.forEach(function (flagIndex) { return _this.setFlag(flagIndex); });
    };
    Bits.prototype.removeFlag = function (flagIndex) {
        var arrayIndex = this.mapFlagIndexToArrayIndex(flagIndex);
        this.state[arrayIndex] = false;
    };
    Bits.prototype.removeFlags = function (flagIndices) {
        var _this = this;
        flagIndices.forEach(function (flagIndex) { return _this.removeFlag(flagIndex); });
    };
    /**
     * The flag index is 1 based, because flagIndex 1 means the first bit
     * Moreover 0 will be the default if no argument provided, and we don't want to use this default
     * @param flagIndex
     * @returns
     */
    Bits.prototype.mapFlagIndexToArrayIndex = function (flagIndex) {
        return flagIndex - 1;
    };
    Object.defineProperty(Bits, "emptyValue", {
        get: function () {
            return new Bits().toString();
        },
        enumerable: false,
        configurable: true
    });
    return Bits;
}());
export default Bits;
//# sourceMappingURL=Bits.js.map